/* AZ Motorsport — combo upsell (PDP bundle + cart-drawer slider).
   Document-delegated so it survives cart-drawer section re-renders.
   Reuses the theme cart flow: POST /cart/add with `sections`, then
   cartDrawer.renderContents(response) (refreshes + opens the drawer). */
(function () {
  'use strict';
  if (window.__azmComboWired) return;
  window.__azmComboWired = true;

  var PREFIX = { CAD: 'CA', USD: 'US', AUD: 'A', NZD: 'NZ', HKD: 'HK', SGD: 'S', MXN: 'MX' };

  // Prices are displayed in presentment currency, en-style ($X,XXX.00), so we
  // sum/parse the displayed strings directly (no base<->presentment conversion).
  function parseAmt(str) { if (!str) return 0; return parseFloat(String(str).replace(/[^\d.]/g, '')) || 0; }
  function symbolOf(str) { var m = String(str || '').match(/^[^\d]+/); return m ? m[0] : ''; }
  function fmtLike(sample, amount) {
    return symbolOf(sample) + amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function getCart() { return document.querySelector('cart-drawer') || document.querySelector('cart-notification'); }

  function applyDiscount(code) {
    if (!code) return Promise.resolve();
    return fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { method: 'GET', headers: { Accept: 'application/json' } }).catch(function () {});
  }

  function showError(btn, msg) {
    var host = btn && (btn.closest('.azm-bundle__foot') || btn.closest('.azm-up') || btn.parentElement);
    if (!host) return;
    var el = host.querySelector(':scope > .azm-error');
    if (!el) { el = document.createElement('div'); el.className = 'azm-error'; el.setAttribute('role', 'alert'); host.appendChild(el); }
    el.textContent = msg;
    clearTimeout(el._t); el._t = setTimeout(function () { if (el && el.parentNode) el.textContent = ''; }, 6000);
  }

  function addItems(items, code, btn) {
    if (!items || !items.length) return Promise.resolve();
    if (btn && btn.dataset.azmBusy) return Promise.resolve(); // re-entrancy guard (blocks keyboard/rapid double-add)
    if (btn) { btn.dataset.azmBusy = '1'; btn.disabled = true; btn.classList.add('is-loading'); }
    var cart = getCart();
    return applyDiscount(code)
      .then(function () {
        var body = { items: items };
        if (cart && cart.getSectionsToRender) {
          body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }
        return fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body),
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) {
          console.warn('[azm-combo] add error:', data.description || data.message);
          showError(btn, data.description || data.message || 'Sorry, this could not be added to your cart.');
          return;
        }
        try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'azm-combo', cartData: data }); } catch (e) {}
        if (cart && cart.renderContents) cart.renderContents(data);
        else window.location = window.routes.cart_url;
      })
      .catch(function (e) { console.error('[azm-combo]', e); showError(btn, 'Something went wrong. Please try again.'); })
      .finally(function () { if (btn) { delete btn.dataset.azmBusy; btn.disabled = false; btn.classList.remove('is-loading'); } });
  }

  function mainVariantId() {
    var el =
      document.querySelector('product-form form [name="id"]') ||
      document.querySelector('form[action*="/cart/add"] [name="id"]');
    return el ? el.value : null;
  }
  function mainPriceEl() {
    return document.querySelector('.azm-pdp-priceline .azm-price__now') || document.querySelector('.product__price .azm-price__now');
  }

  function rowVariantId(row) {
    var v = row && row.querySelector('[data-azm-variant]');
    return v ? v.value : null;
  }

  // ---- variant select: swap displayed price, then recompute the bundle total ----
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('select[data-azm-variant]');
    if (sel) {
      var opt = sel.selectedOptions[0];
      var row = sel.closest('[data-azm-row]');
      if (opt && row) {
        var priceEl = row.querySelector('[data-azm-price]');
        if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      }
      recompute(sel.closest('[data-azm-bundle]'));
      return;
    }
    if (e.target.closest('[data-azm-check]')) recompute(e.target.closest('[data-azm-bundle]'));
  });

  // ---- add buttons ----
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-azm-add]');
    if (addBtn) {
      e.preventDefault();
      var id = rowVariantId(addBtn.closest('[data-azm-row]'));
      if (id) addItems([{ id: Number(id), quantity: 1 }], addBtn.dataset.code, addBtn);
      return;
    }
    var bundleBtn = e.target.closest('[data-azm-add-bundle]');
    if (bundleBtn) { e.preventDefault(); addBundle(bundleBtn.closest('[data-azm-bundle]'), bundleBtn); }
  });

  function addBundle(bundle, btn) {
    if (!bundle) return;
    var items = [];
    var mid = mainVariantId();
    if (mid) items.push({ id: Number(mid), quantity: 1 });
    var partnersChecked = 0;
    bundle.querySelectorAll('[data-azm-partner]').forEach(function (row) {
      var chk = row.querySelector('[data-azm-check]');
      if (chk && chk.checked) { var id = rowVariantId(row); if (id) { items.push({ id: Number(id), quantity: 1 }); partnersChecked++; } }
    });
    // The combo discount only applies to a real combo — never to the single item alone.
    var code = partnersChecked >= 1 ? bundle.dataset.code : null;
    if (items.length) addItems(items, code, btn);
  }

  // ---- bundle live total ----
  function recompute(bundle) {
    if (!bundle) return;
    var total = 0, maxItem = 0, sample = '', checkedPartners = 0;
    var mainRow = bundle.querySelector('[data-azm-main]');
    if (mainRow) {
      var mpe = mainPriceEl(), mrp = mainRow.querySelector('[data-azm-price]');
      if (mpe && mrp) mrp.textContent = mpe.textContent.trim(); // mirror the live PDP price
      var mAmt = parseAmt(mrp && mrp.textContent);
      total += mAmt; if (mAmt > maxItem) maxItem = mAmt; if (!sample && mrp) sample = mrp.textContent;
    }
    bundle.querySelectorAll('[data-azm-partner]').forEach(function (row) {
      var chk = row.querySelector('[data-azm-check]');
      if (chk && !chk.checked) return;
      checkedPartners++;
      var pe = row.querySelector('[data-azm-price]');
      var a = parseAmt(pe && pe.textContent);
      total += a; if (a > maxItem) maxItem = a; if (!sample && pe) sample = pe.textContent;
    });
    var rate = (parseFloat(bundle.dataset.rate || '0') || 0) / 100;
    // Discount applies only to a real combo — at least one partner must be checked.
    var savings = (checkedPartners >= 1 && rate > 0) ? maxItem * rate : 0;
    var nowEl = bundle.querySelector('[data-azm-total]');
    var wasEl = bundle.querySelector('[data-azm-was]');
    var saveEl = bundle.querySelector('[data-azm-save]');
    if (nowEl) nowEl.textContent = fmtLike(sample, total - savings);
    if (wasEl) { if (savings > 0) { wasEl.textContent = fmtLike(sample, total); wasEl.hidden = false; } else { wasEl.hidden = true; } }
    if (saveEl) saveEl.hidden = savings <= 0;
  }

  // recompute when the main product variant changes (price DOM updates async → defer a tick)
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(function () { document.querySelectorAll('[data-azm-bundle]').forEach(recompute); }, 60);
      });
    }
  } catch (e) {}

  function init() { document.querySelectorAll('[data-azm-bundle]').forEach(recompute); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
